export const axiom = async (abortController, data) => {
  try {
    fetch("https://cloud.axiom.co/api/v1/datasets/auction/ingest", {
      signal: abortController.signal,
      method: "POST",
      headers: {
        Authorization: "Bearer xaat-5f168000-45b1-4478-aa49-e6abd7bde0e0",
        "Content-Type": "application/x-ndjson",
      },
      body: JSON.stringify(data),
    });
  } catch (e) {
    console.log("unable to send logs", e);
  }
};
